// extracted by mini-css-extract-plugin
export default {"overlay":"BtcFaucetTracker_overlay__Ly6E+","modal":"BtcFaucetTracker_modal__cbmG-","cta":"BtcFaucetTracker_cta__3aJkO"};